import { updateChat } from 'lib/api/smsApi';
import { GLOBAL_ACTIONS, useGlobalDispatch } from 'lib/context';
import { countMessageNotifications } from 'lib/utils/messageNotifications';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

export const useUpdateChatMutation = (dateSelected: string, userData: any) => {
  const history = useHistory();
  const isMessagesRoute = history.location.pathname === '/sms/messages';
  const queryClient = useQueryClient();
  const { dispatch } = useGlobalDispatch();
  return useMutation(updateChat, {
    onSuccess: res => {
      if (isMessagesRoute) {
        history.push(`/sms/chats/${res.chatId}?range=${dateSelected}`);
      }
    },

    onError: (err, variables, previousValue: any) => {
      queryClient.setQueryData(['messages', '', dateSelected], previousValue);
      dispatch({
        type: GLOBAL_ACTIONS.INCREMENT_CONVERSATION_NOTIFICATION,
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries(['messages']);
    },
    onMutate: res => {
      queryClient.cancelQueries(['messages']);
      const cache: any = queryClient.getQueryData([
        'messages',
        '',
        dateSelected,
      ]);

      const oldMessages = cache?.chats.map((chat: any) => {
        if (`${res}` === `${chat.chatId}`)
          return {
            ...chat,
            lastReadAt: new Date().toISOString(),
          };
        return chat;
      });

      queryClient.setQueryData(['messages', '', dateSelected], {
        chats: oldMessages,
        count: cache?.count || 0,
      });

      const unreadMessagesCount = countMessageNotifications(
        oldMessages || [],
        userData.userId
      );

      dispatch({
        type: GLOBAL_ACTIONS.SET_UNREAD_MESSAGES,
        payload: unreadMessagesCount,
      });

      return cache;
    },
  });
};
